'use strict';

var _regeneratorRuntime = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator");

var _objectSpread = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectSpread2");

var _objectWithoutProperties = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/objectWithoutProperties");

var _asyncToGenerator = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/asyncToGenerator");

var _excluded = ["timeout", "signal", "headers"];
Object.defineProperty(exports, '__esModule', {
  value: true
});

var utils = require('./utils.js');

function createRmAll(client) {
  function rmAll(_x) {
    return _rmAll.apply(this, arguments);
  }

  function _rmAll() {
    _rmAll = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
      var timeout, signal, headers, query;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              timeout = _ref.timeout, signal = _ref.signal, headers = _ref.headers, query = _objectWithoutProperties(_ref, _excluded);
              _context.next = 3;
              return client.post('pin/remote/rm', {
                timeout: timeout,
                signal: signal,
                headers: headers,
                searchParams: utils.encodeQuery(_objectSpread(_objectSpread({}, query), {}, {
                  all: true
                }))
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return _rmAll.apply(this, arguments);
  }

  return rmAll;
}

exports.createRmAll = createRmAll;